import { POPULAR_CATEGORIES } from '../constants/landing';
import { GalleryPlaceholder } from '../assets/profile';

const getCategoryArticleFeatureImage = (name, images) => {
  const { results = [] } = images || {};
  const firstImage = results.reduce((agg, item) => {
    const { article } = item || {};
    const { featureImageUrl } = article || {};
    if (!agg && featureImageUrl) return featureImageUrl;
    return agg;
  }, null);
  return (
    firstImage ||
    ((POPULAR_CATEGORIES.filter(item => item.name === name) || [])[0] || {})
      .image ||
    GalleryPlaceholder
  );
};

export default getCategoryArticleFeatureImage;
